export const NAME = 'landrysInvoices';
